import { ReactElement } from 'react';
import classnames from 'classnames';
import styles from './TextInputWDP.module.scss';

interface iProps {
  title?: string;
  subtitle: string;
  placeholder: string;
  icon?: any;
  iconPosition?: 'start' | 'end';
  iconClick?: () => void;
  onChange?: (e: any) => void;
  type?: string;
  value?: string;
}

const TextInputWDP = ({ title = '', subtitle, placeholder, icon, iconPosition = 'start', iconClick, type = 'text', onChange, value = '' }: iProps): ReactElement => {
  const extraInputAttrs: any = {};

  return (
    <div
      className={classnames({
        [styles.container]: true,
        [styles.titlePresent]: title,
      })}>
      {title && (
        <div
          className={classnames({
            [styles.title]: true,
          })}>
          <span className={styles.titleBold}>{title}</span>
          {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
        </div>
      )}
      <div className={styles.inputContainer}>
        <input
          type={type}
          className={classnames({
            [styles.formInput]: true,
            [styles.inputLeftPadding]: icon && iconPosition === 'start',
          })}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          {...extraInputAttrs}
        />
        {icon && !iconClick && (
          <div>
            <img
              className={classnames({
                [styles.iconContainerStart]: iconPosition === 'start',
                [styles.iconContainerEnd]: iconPosition === 'end',
              })}
              src={icon}
              alt="icon" />
          </div>
        )}
        {icon && iconClick && (
          <button
            type="button"
            onClick={iconClick}
            className={classnames({
              [styles.iconContainerStart]: iconPosition === 'start',
              [styles.iconContainerEnd]: iconPosition === 'end',
              [styles.iconButton]: true,
            })}>
            <img src={icon} alt="icon" />
          </button>
        )}
      </div>
    </div>
  );
};

export default TextInputWDP;
